export default "__VITE_ASSET__CkMH5yaE__"